import { CopyAll } from '@mui/icons-material';
import { Avatar, Box, Grid, Paper, Typography, styled } from '@mui/material';
import { ReactEventHandler } from 'react';
import {
  WsColors,
  WsButton,
  WsTitleHeader,
  WsTitleColors,
  WsDotColors,
  WsDotIcon,
  theme,
} from 'wisestep-base';

interface BooleanQryCardProps {
  title: string;
  subtitle?: string;
  jobAcceptedByCount?: number;
  leadGenerationsCount?: number;
  submissionsCount?: number;
  profileUrl?: string;
  profileAlt?: string;
  onclick?: ReactEventHandler;
}
const HeaderTheme = styled(Grid)(() => ({
  borderRadius: 1,
  backgroundColor: WsColors.TertiaryShades50,
  padding: theme.spacing(1),
  justifyContent: 'space-between',
}));
export default function TeamsCard({
  title,
  subtitle,
  jobAcceptedByCount,
  submissionsCount,
  leadGenerationsCount,
  profileUrl,
  profileAlt,
  onclick,
}: BooleanQryCardProps) {
  return (
    <Paper variant="outlined" sx={{ borderRadius: 1 }}>
      <HeaderTheme xs={12} container alignItems="center">
        <WsTitleHeader
          title={title}
          subtitle={subtitle}
          color={WsTitleColors.BLACK}
          startIcon={<Avatar alt={profileAlt} src={profileUrl} />}
        />
        <WsButton variant="text" size="small" startIcon={<CopyAll />} onClick={onclick}>
          Unassign
        </WsButton>
      </HeaderTheme>
      <Grid xs={12} container justifyContent="space-around">
        {jobAcceptedByCount && (
          <Box py={2}>
            <Typography fontSize="10px" color={WsColors.TertiaryShades500}>
              Job Accepted by
            </Typography>
            <Typography fontSize="14px" fontWeight="bold" color={WsColors.TertiaryShades500}>
              {jobAcceptedByCount}
            </Typography>
          </Box>
        )}
        {leadGenerationsCount && (
          <Box py={2}>
            <Typography fontSize="10px" color={WsColors.TertiaryShades500}>
              Lead Generations
            </Typography>
            <WsDotIcon value={leadGenerationsCount} color={WsDotColors.YELLOW} />
          </Box>
        )}
        {submissionsCount && (
          <Box py={2}>
            <Typography fontSize="10px" color={WsColors.TertiaryShades500}>
              Submissions
            </Typography>
            <WsDotIcon value={submissionsCount} color={WsDotColors.GREEN} />
          </Box>
        )}
      </Grid>
    </Paper>
  );
}
